module.exports = __webpack_public_path__ + "static/media/wordpress.38f3b4b3.svg";